import axios from "axios";

import nprogress from 'nprogress';
import 'nprogress/nprogress.css';

// 请求拦截器
axios.interceptors.request.use(
    (config) => {

        //启动进度条
        nprogress.start();

        return config;
    },
    (error) => {
        console.log(error);
    }
);

// 响应拦截器 - 统一处理消息提示
axios.interceptors.response.use(
    (success) => {

        //关闭进度条
        nprogress.done();

        //console.log(success);
        // 业务逻辑错误
        if (success.status && success.status === 200) {
            // 调到接口
            // 后端：500 业务逻辑错误，401 未登录，403 无权访问；
            if (success.data.meta && (
                success.data.meta.status === 500 ||
                success.data.meta.status === 401 ||
                success.data.meta.status === 403)
            ) {
                //Message.error({message: success.data.meta.msg});
                return;
            }
            if (success.data.message) {
                // 输出后端 添加成功 之类的信息
                //Message.success({message: success.data.meta.msg});
            }
        }
        return success.data;
    },
    (error) => {

        //关闭进度条
        nprogress.done();

        // const respObj = error.response;

        return;
    }
);

// 预备前置路径
let base = process.env.VUE_APP_URL;
//let base = 'http://127.0.0.1:9090/top/upay/api/';

// 传送 json 格式的 post 请求
export const postRequest = (url, params) => {
    return axios({
        method: "post",
        url: `${base}${url}`,
        data: params,
    });
};

// 传送 json 格式的 get 请求
export const getRequest = (url, params) => {
    return axios({
        method: "get",
        url: `${base}${url}`,
        params: params,
    });
};

// 传送 json 格式的 put 请求
export const putRequest = (url, params) => {
    return axios({
        method: "put",
        url: `${base}${url}`,
        params: params,
    });
};

// 传送 json 格式的 delete 请求
export const deleteRequest = (url, params) => {
    return axios({
        method: "delete",
        url: `${base}${url}`,
        params: params,
    });
};

